import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const Wallet2Bold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M17.5097 13.5305C17.0897 13.9405 16.8497 14.5305 16.9097 15.1605C16.9997 16.2405 17.9897 17.0305 19.0697 17.0305H20.9697V18.2205C20.9697 20.2905 19.2797 21.9805 17.2097 21.9805H5.72973C3.65973 21.9805 1.96973 20.2905 1.96973 18.2205V11.4905C1.96973 9.42047 3.65973 7.73047 5.72973 7.73047H17.2097C19.2797 7.73047 20.9697 9.42047 20.9697 11.4905V12.9305H18.9497C18.3897 12.9305 17.8797 13.1505 17.5097 13.5305Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14.3197 3.9298V7.7298H5.72973C3.65973 7.7298 1.96973 9.4198 1.96973 11.4898V7.8198C1.96973 6.6298 2.69973 5.5698 3.80973 5.1498L11.7497 2.1498C12.9897 1.6798 14.3197 2.5998 14.3197 3.9298Z"
                        fill={color}
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M1.96973 12.3902V11.4902" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M22.0295 13.9497V16.0097C22.0295 16.5597 21.5895 17.0097 21.0295 17.0297H19.0695C17.9895 17.0297 16.9995 16.2397 16.9095 15.1597C16.8495 14.5297 17.0895 13.9397 17.5095 13.5297C17.8795 13.1497 18.3895 12.9297 18.9495 12.9297H21.0295C21.5895 12.9497 22.0295 13.3997 22.0295 13.9497Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill={color} />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
